export const buildPermissionSet = (permissions = []) => {
  if (!Array.isArray(permissions)) {
    return new Set();
  }

  return new Set(
    permissions
      .filter(Boolean)
      .map((permission) => permission.trim())
  );
};

export const checkPermission = (
  permissionSet,
  permission
) => {
  if (!permission || !permissionSet) {
    return false;
  }

  return (
    permissionSet.has('*') ||
    permissionSet.has(permission)
  );
};

export const checkAnyPermission = (
  permissionSet,
  permissions = []
) => {
  if (!permissions.length) {
    return false;
  }

  return permissions.some((permission) =>
    checkPermission(permissionSet, permission)
  );
};

export const checkAllPermissions = (
  permissionSet,
  permissions = []
) => {
  if (!permissions.length) {
    return false;
  }

  return permissions.every((permission) =>
    checkPermission(permissionSet, permission)
  );
};

export const mergePermissions = (orgPermissions = [], projectPermissions = []) =>
  [...new Set([...orgPermissions, ...projectPermissions].filter(Boolean))];